module.exports = __webpack_public_path__ + "static/media/avatar_lion.3fe3a183.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_lion.png
// module id = 388
// module chunks = 0